import styles from './MobileBgOrangeBlur.module.scss'


const MobileBgOrangeBlur: React.FC = () => {
    return (
    <div className={styles.container}></div>
    )
}
export default MobileBgOrangeBlur